import { useRecoilValue } from "recoil";
import { mapTypeObjectState } from "../states/mapState";
import { themedUseStyletron } from "../styles/theme";
import { ROAD_MAP_OBJ } from "../constants/mapConstants";

export function useTheme() {
    const [css, theme] = themedUseStyletron();
    const mapTypeObjectFromState = useRecoilValue(mapTypeObjectState);
    const mapTypeObject = mapTypeObjectFromState || ROAD_MAP_OBJ;
    const isDarkTheme = mapTypeObject.isDark;

    return { css, theme, isDarkTheme };
}